import { render, staticRenderFns } from "./p19.vue?vue&type=template&id=40665a0c&scoped=true&"
import script from "./p19.vue?vue&type=script&lang=js&"
export * from "./p19.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40665a0c",
  null
  
)

export default component.exports